// extracted by mini-css-extract-plugin
export default {"title":"PageHeader_title__YDhmh","subtitle":"PageHeader_subtitle__9M7NJ"};